import { render, staticRenderFns } from "./PublicExamsList.vue?vue&type=template&id=24b9f770"
import script from "./PublicExamsList.vue?vue&type=script&lang=js"
export * from "./PublicExamsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports